import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React, { useEffect } from 'react';

import { RootStackParamList } from '../navigator';

type Props = NativeStackScreenProps<RootStackParamList, 'Conversations'>;

/**
 * The `chats` link: the chat list is the Message Center's Private Chat tab now, so this only
 * opens the Message Center on it.
 */
const ConversationsScreen: React.FC<Props> = ({ navigation }) => {
	useEffect(() => {
		navigation.replace('Messages', { tab: 'chats' });
	}, [navigation]);

	return null;
};

export default ConversationsScreen;
